import types from '../types/missingInfo'
import {Map} from 'immutable'

const initialRoot = Map({
  afterDone: null,
  step: 0,
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.SET_AFTER_DONE:
      return state.merge({
        afterDone: action.payload.afterDone,
      })
    case types.NEXT_STEP:
      return state.set('step', action.payload.step)
    case types.CLOSE:
      return state.merge({
        step: 0,
        afterDone: null,
      })
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/missingInfo/reducers/missingInfo.js